/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import StarIcon from '@mui/icons-material/Star';
import { Button, Table, TableBody, TableCell, TableContainer, TableRow, Box } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { showError } from '../../constants/toasts';
import { useLazyGetRatingQuery } from '../../service/rating';
import { Rating } from '../../types/General';

const FeedbackReview = () => {
  const navigate = useNavigate();

  const [anchorEl1, setAnchorEl1] = React.useState<null | HTMLElement>(null);
  const [rating, setRating] = useState<Rating[]>();
  const [count, setCount] = useState<number>(0);
  const [getRating] = useLazyGetRatingQuery();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const getRatingList = async () => {
    setIsLoading(true);

    try {
      const body = {
        page: 1,
        length: 3,
      };
      const res = await getRating({
        page: 1,
        limit: 3,
        search: '',
      }).unwrap();
      if (res?.statusCode === 200) {
        setRating(res?.data?.data || []);
        setCount(res?.data?.count);
      } else {
        setRating([]);
      }
    } catch (error: any) {
      showError(error?.data?.message || '');
    }
    setIsLoading(false);
    // ref?.current?.complete();
  };
  const open1 = Boolean(anchorEl1);
  const handleClick1 = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl1(event.currentTarget);
  };
  const handleClose1 = () => {
    setAnchorEl1(null);
  };

  const [anchorEl2, setAnchorEl2] = React.useState<null | HTMLElement>(null);
  const open2 = Boolean(anchorEl2);
  const handleClick2 = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl2(event.currentTarget);
  };
  const handleClose2 = () => {
    setAnchorEl2(null);
  };

  const [anchorEl3, setAnchorEl3] = React.useState<null | HTMLElement>(null);
  const open3 = Boolean(anchorEl3);
  const handleClick3 = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl3(event.currentTarget);
  };
  const handleClose3 = () => {
    setAnchorEl3(null);
  };

  useEffect(() => {
    getRatingList();
  }, []);

  return (
    <>
      <div className="cards cards_100 table_card">
        <div className="cards_header">
          <div className="left_s">
            <h2>Store Feedback and Review</h2>
            <p>More than {count} feedbacks</p>
          </div>
          {/* <div className="right_s">
            <p>
              <span>Month</span>
              <span>Week</span>
              <span>Today</span>
            </p>
            <Button className="btn btn_highlight">
              <img src="/static/images/upload_icon.svg" alt="Icon" /> Export
            </Button>
          </div> */}
        </div>
        <TableContainer className="table_container">
          <Box className="heading"></Box>
          <Table aria-label="simple table">
            <TableBody>
              {rating
                ? rating?.map((item, i) => (
                    <TableRow key={i}>
                      <TableCell>
                        <div className="user_block">
                          <figure
                          //
                          >
                            <img
                              src={item?.sellerImage || '/static/images/user_attachment.jpg'}
                              alt=""
                            />
                          </figure>
                          <p>
                            <b>{item?.sellerName || '-'}</b> {item?.sellerEmail || '-'}
                          </p>
                        </div>
                      </TableCell>
                      <TableCell>
                        {item?.sellerDialCode || '-'}
                        {item?.sellerPhoneNo || '-'}
                      </TableCell>
                      <TableCell>
                        <div className="sq_image" style={{ marginTop: '16px' }}>
                          <figure>
                            <img
                              width={'120px'}
                              height={'60px'}
                              src={item?.coverImage || '/static/images/vehicle_side.jpg'}
                              alt=""
                            />
                          </figure>
                        </div>
                      </TableCell>
                      {/* <TableCell>{item?.title || "-"}</TableCell> */}
                      {/* <TableCell className="max_c">
                  <p>
                    Lorem Ipsum is simply dummy text of the printing and
                    typesetting industry.
                  </p>
                </TableCell> */}
                      <TableCell>
                        {(() => {
                          const arr = new Array(item?.rating).fill(0); // fill needed to create actual elements
                          return (
                            <div className="star_rating">
                              {arr.map((_, index) => (
                                <StarIcon key={index} className="active" />
                              ))}
                            </div>
                          );
                        })()}
                      </TableCell>
                    </TableRow>
                  ))
                : null}
            </TableBody>
          </Table>
        </TableContainer>
        <div className="text_center">
          <Button variant="outlined" onClick={() => navigate('/ratings-and-reviews')}>
            Show More
          </Button>
        </div>
      </div>
    </>
  );
};

export default FeedbackReview;
